import { InventoryAlertType } from "../../services/interface/IAlerts";
import { Link } from "react-router-dom";
import { transformTitle, formatter } from "../../utils/formatter";
import { InventoryAlertKeys } from "../../utils/dataconstants";
import inc from "../../assets/inc.svg";
import dec from "../../assets/dec.svg";
import useNavigateHandler from "../../common/useNavigateHandler";

type Props = { card: InventoryAlertType };

export const InventoryCard = ({ card }: Props) => {
    const alertKey = InventoryAlertKeys[card.title as keyof typeof InventoryAlertKeys];
    const indicator = card.prevWeekCount!=null ? card.prevWeekCount < card.amount ? inc : dec : "";
    const {navigateTo} = useNavigateHandler();
    return (
        <div onClick={()=>navigateTo(`/inventory/inventory-alerts?alert=${transformTitle(alertKey)}`)} style={{ textDecoration: "none" }}>
            <div className="bg-white shadow-module-card 
            py-[1vh] px-[0.6vw] h-[7.0vw] rounded flex flex-col justify-between cursor-pointer">
                <p className="home-page-alerts-title font-semibold">{alertKey}</p>
                <div className="flex flex-col">
                    <div className="flex gap-1">
                        <span className={`home-page-alerts-indicator leading-none 
                                ${indicator === inc && "text-alert"}
                                ${indicator === dec && "text-deloitteGreen"}
                                ${indicator === "" && "text-[#ff9d00]"} `}>{card?.totalCount}</span>
                        {indicator!=="" && <img className="w-[1vw]" src={indicator} alt="Indicator" />}
                    </div>
                    <span className="home-page-alerts-footer">${formatter(card?.amount)}</span>
                </div>
            </div>
        </div>
    );
};
